import React from "react";
import './styles.scss';
import { TypeBlock } from "../../../types/blocks";

const SVG = ({ attributes, content, className, style }: TypeBlock) => {

  const { code } = attributes;

  return React.createElement(
    "div",
    {
      className: className,
      style: style,
      dangerouslySetInnerHTML: { __html: code },
    },
  );
};

export default SVG;
